"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// e.which and e.keyCode are deprecated
// This export will be removed in next major release
// Source: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
var KEY_CODES = {
  DOWN: '40',
  UP: '38',
  HOME: '36',
  END: '35',
  LEFT: '37',
  RIGHT: '39',
  ENTER: '13',
  SPACE: '32'
};
var _default = KEY_CODES;
exports["default"] = _default;